import styled from 'styled-components'
import colors from '@rodeo-dev/legos/dist/themes/colors'

const Anchor = styled.a`
  color: ${colors.text.primary};

  &:visited {
    color: ${colors.text.primary};
  }

  &:hover,
  &:focus {
    color: ${colors.error.main};
  }
`

export default Anchor
